<template>
	<div style="display: inline-block;">
		<Button class="jxyd-borderbtn jxyd-searchbtn" title="添加套餐" @click="openSelectPackageModal" style="margin-right:10px;"
			:disabled="isDisabled">
			<Icon type="md-add-circle" size='18'/> 添加
		</Button>
		<Modal v-model="selectPackageModal" draggable sticky scrollable :fullscreen="fullscreen" :width="1000"
			:styles="{top: '20px','backgroud-color':'white'}">
			<p slot="header" class="modal-header">
				<img src="/static/imgs/taocan.png" class="jxyd-imgicon" />
				<span style="float: left;font-weight: bold;">选取套餐</span>
			</p>
			<div class="modal-content">
				<div style="padding: 16px;">
					<div id="box-search">
						<div class="box-search-left">
							<Input type="text" class="search_input" v-model="searchItems.searchVal" placeholder="请输入套餐名/条码/规格/种类/仓库/货位/备注" @keyup.enter.native="initPackageList(1)" />
							<button class="jxyd-button jxyd-primary jxyd-searchbtn" @click="initPackageList(1)">查询</button>
						</div>
						<Button class="jxyd-borderbtn box-search-right" @click="addPackage" v-show="permission.isAdd">
							新建套餐
						</Button>
					</div>
					<Table stripe :height='500' :columns="packageColumn" :data="packageData" @on-select="listSelected"
						@on-select-cancel='listSelectedCanel' @on-select-all='listSelectAll' @on-select-all-cancel='listSelectAllCanel'>
					</Table>
					<div id="page-box">
						<Page show-sizer :total="packageCount" :page-size="searchItems.pageSize" @on-change="pageChange"
							show-total show-elevator :page-size-opts ='pageSizeOpts' :current="searchItems.pageIndex" @on-page-size-change='pageSizeChange'>
						</Page>
					</div>
				</div>
				<!-- 自定义抽屉组件 -->
				<transition name="slide-right">
					<div v-if="shoppingCart" class="custom-drawer">
						<div class="drawer-title">
							<div class="drawer-title-left">
								已选
								<span class="drawer-title-left-number">
									{{tableRows.length}}
								</span>
							</div>
							<div class="drawer-title-right" @click="cleanSelected">清空已选</div>
						</div>
						<Table :height='680' disabled-hover :columns="selectedColumn" :data="tableRows">
						</Table>
					</div>
				</transition>
			</div>
			<div slot="footer">
				<div class="selected-goods" @click="shoppingCart=!shoppingCart">
					<Icon type="md-cart" size='20'/>
					<Badge :count="tableRows.length">
						<span>已选套餐</span>
					</Badge>
				</div>
				<div class="footer-tool">
					<button class="jxyd-button" @click="selectPackageModal = false">取消</button>
					<button class="jxyd-button jxyd-primary" type="primary" @click="Submit">确定</button>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
    import formatDate from '@/utils/formatDate'

	export default {
		name: 'selectPackageModal',
		props: ['selectedPackage', 'isDisabled', 'isStock'],
		data() {
			return {
				selectPackageModal: false,
				fullscreen: false,
				packageColumn: [
				    {
				        type: 'selection',
				        width: 80,
				        align: 'center',
				        fixed: 'left'
				    },
				    {
				        title: '套餐图片',
				        key: 'imgFile',
				        width: 100,
				        render(h, params) {
				            return [h('Poptip', {
				                attrs: {
				                    'placement': "right",
				                    transfer: true
				                }
				            }, [h('Avatar', {
				                style: {
				                    'width': '40px',
				                    'height': '40px',
				                    'cursor': 'pointer'
				                },
				                attrs: {
				                    'src': params.row.imgFile.length > 0 ? params.row.imgFile[0].url : '/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
				                }
				            }), h('div', {
				                slot: "content"
				            }, [h('Avatar', {
				                style: {
				                    'width': '120px',
				                    'height': '120px'
				                },
				                attrs: {
				                    'src': params.row.imgFile.length > 0 ? params.row.imgFile[0].url : '/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
				                }
				            })])])];
				        }
				    },
				    {
				        title: '套餐条码',
				        key: 'code',
				        width: 150
				    },
				    {
				        title: '套餐名称',
				        key: 'name',
				        width: 250,
				        render:(h, params)=> {
				            return h('a',{
				            	class:'jxyd-a',
				            	on: {
				            	    click: (e) => {
										this.selectPackageModal = false;
				            	        this.$router.push({
				            	        	path: 'packagedetailinfo',
				            				query: {
				            					packageId: params.row.id
				            				}
				            	        });
				            	    }
				            	}
				            },params.row.name);
				        }
				    },
				    {
				        title: '套餐种类',
				        key: 'type',
				        width: 150
				    },
				    {
				        title: '折扣',
				        key: 'discount',
				        width: 150
				    },
				    {
				        title: '套餐采购总金额',
				        key: 'purchaseAmount',
				        width: 200,
				    },
				    {
				        title: '套餐采购总金额',
				        key: 'salesAmount',
				        width: 200,
				    },
				    {
				        title: '创建时间',
				        key: 'createDate',
				        width: 200,
				        render: (h, params) => {
				            return h('span', {}, formatDate(new Date(params.row.createDate), 'yyyy-MM-dd'));
				        }
				    },
				    {
				        title: '备注',
				        key: 'note',
				        width: 400
				    }
				],
				packageData: [],
				packageCount: 0,
				tableRows: [],
				searchItems: {
					searchVal: '',
					pageSize: 10,
					pageIndex: 1,
					isStock: this.isStock
				},
				advancedSelect: false,
				shoppingCart: false,
				selectedColumn: [{
						title: '套餐图片',
						key: 'imgFile',
						width: 100,
						render(h, params) {
							return [h('Poptip', {
								attrs: {
									'placement': "right",
									transfer: true
								}
							}, [h('Avatar', {
								style: {
									'width': '40px',
									'height': '40px',
									'cursor': 'pointer',
									
								},
								attrs: {
									'src': params.row.imgFile.length > 0 ? params.row.imgFile[0].url :
										'/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
								}
							}), h('div', {
								slot: "content"
							}, [h('Avatar', {
								style: {
									'width': '120px',
									'height': '120px'
								},
								attrs: {
									'src': params.row.imgFile.length > 0 ? params.row.imgFile[
											0].url :
										'/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
								}
							})])])];
						}
					},
					{
					    title: '套餐名称',
					    key: 'name',
					    width: 250,
					    render:(h, params)=> {
					        return h('a',{
					        	class:'jxyd-a',
					        	on: {
					        	    click: (e) => {
										this.selectPackageModal = false;
					        	        this.$router.push({
					        	        	path: 'packagedetailinfo',
					        				query: {
					        					packageId: params.row.id
					        				}
					        	        });
					        	    }
					        	}
					        },params.row.name);
					    }
					},
					{
						title: '单位',
						key: 'unit',
						width: 100
					},
					{
						title: '规格',
						key: 'format',
						width: 100
					},
					{
					    title: '操作',
					    key: 'action',
					    align: 'center',
					    fixed: 'right',
						width:80,
					    render: (h, params) => {
					        return h('a', {
								class:'jxyd-a',
					            props: {
					            },
					            style: {
					            },
					            on: {
					                click: (val) => {
					                    this.tableRows.splice(params.index,1);
										this.initPackageList(1);
					                }
					            }
					        },"删除");
					    }
					}
				],
				pageSizeOpts:[10,20,30,40,50,60,70,80,90,100],
				permission:{
					isAdd:false
				}
			}
		},

		methods: {
			Submit() {
				if (this.tableRows.length < 1) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择套餐"
					});
					return;
				}
				this.$emit('getResult', this.tableRows);
				this.selectPackageModal = false;
			},
			openSelectPackageModal() {
				if(this.selectedPackage.length != this.tableRows.length){
					this.tableRows = JSON.parse(JSON.stringify(this.selectedPackage));
				}
				this.initPackageList(1);
				this.selectPackageModal = true;
			},
			initPackageList(index) {
				let component = this;
				component.searchItems.pageIndex = index;
				request.post('/api/CommodityPackage/GetCommodityPackageToModal', component.searchItems).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					component.packageData = response.data.commodityPackage;
					component.packageCount = response.data.count;
					component.initSelectedRow();
				}).catch(function(error) {})
			},
			initSelectedRow() {
				this.tableRows.forEach((item, index) => {
					this.packageData.forEach((item2,index2)=>{
						if(item.id == item2.id){
							item2._checked = true;
						}
					});
				});
			},
			pageChange(index) {
				this.initPackageList(index);
			},
			pageSizeChange(pageSize){
				this.searchItems.pageSize = pageSize;
				this.initPackageList(1);
			},
			listSelectAll(items){
				let isExist = false;
				for(let i = 0;i<items.length;i++){
					isExist = false;
					for(let n = 0; n<this.tableRows.length;n++){
						if(items[i].id === this.tableRows[n].id){
							isExist = true;
							break;
						}
					}
					if(!isExist){
						this.tableRows.push(items[i]);
					}
				}
			},
			listSelectAllCanel(items){
				for(let i = 0;i<this.packageData.length;i++){
					for(let n = 0; n<this.tableRows.length;n++){
						if(this.packageData[i].id === this.tableRows[n].id){
							this.tableRows.splice(n,1);
							break;
						}
					}
				}
			},
			listSelected(items, row) {
				this.tableRows.push(row);
			},
			listSelectedCanel(items, row) {
				this.tableRows.forEach((item,index)=>{
					if(row.id == item.id){
						this.tableRows.splice(index, 1);
					}
				});
			},
			cleanSelected(){
				this.tableRows = [];
				this.initPackageList(1);
			},
			addPackage() {
				this.selectPackageModal = false;
				this.$router.push({
					path: 'packagefunc'
				});
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['CommodityPackage.Add'],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
						self.$Modal.warning({
							title:'系统到期提示',
							content: response.errorMsg,
							onOk:() => {
								localStorage.setItem("_tipTimeoutCount",1);
							}
						});
					}
					if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
						localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'CommodityPackage.Add':
								self.permission.isAdd = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			}
		},
		watch: {
		},
		created: function() {
			this.initPermission();
		}
	}
</script>

<style scoped>
	#page-box {
		margin-top: 15px;
		text-align: center;
	}

	.selected-goods {
		float: left;
		height: 52px;
		line-height: 52px;
		text-align: center;
		width: 150px;
		color: #fff;
		background-color: rgb(255, 106, 127);
		font-size: 15px;
		cursor: pointer;
		font-weight: bold;
	}

	/deep/ .ivu-modal-footer {
		padding: 0px !important;
	}

	.footer-tool {
		padding: 10px;
	}

	/deep/ .ivu-badge-count {
		top: -3px;
	}

	.drawer {
		width: 300px;
		height: 500px;
		background-color: aqua;
	}

	/* 过渡动画样式 */
	.slide-right-enter-active,
	.slide-right-leave-active {
		transition: all 0.3s ease;
	}

	.slide-right-enter,
	.slide-right-leave-to {
		transform: translateX(100%);
	}

	/* 自定义抽屉样式 */
	.custom-drawer {
		position: absolute;
		top: 0;
		right: 0;
		width: 450px;
		/* 可调整抽屉宽度 */
		height: 100%;
		/* 充满模态框高度 */
		background-color: #fff;
		box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
		z-index: 1000;
		/* 确保在模态框内容之上 */
		/* overflow-y: auto;
		如果内容超出，可滚动 */
		padding: 10px;
	}

	/deep/ .ivu-modal-content {
		background-color: white;
	}

	/deep/ .ivu-modal-body {
		padding: 0px;
	}

	.drawer-title {
		margin-bottom: 10px;
	}

	#box-search{
		margin-bottom: 15px;
		overflow: hidden;
	}
	
	.search_input{
		width: 200px;
		margin-right: 15px;
	}
	
	.box-search-left{
		float: left;
	}
	
	.box-search-right{
		float: right;
	}
	.modal-header{
		overflow:hidden;
		color:rgb(255, 106, 127);
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
</style>